import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    totalLoyaltyTransactions: 0,
    totalPromotionSales: 0,
    totalVoucherRedeemed: 0,
    totalVoucherValue: 0,
    totalPromotionQuantitySold: 0,
    totalPromotionSold: 0,
};

const getters = {
    totalLoyaltyTransactions: state => state.totalLoyaltyTransactions,

    totalPromotionSales: state => state.totalPromotionSales,

    totalVoucherRedeemed: state => state.totalVoucherRedeemed,

    totalVoucherValue: state => state.totalVoucherValue,

    totalPromotionQuantitySold: state => state.totalPromotionQuantitySold,

    totalPromotionSold: state => state.totalPromotionSold,
};

const mutations = {
    setTotalLoyaltyTransactions(state, data) {
        state.totalLoyaltyTransactions = data;
    },

    setTotalVoucherRedeemed(state, data) {
        state.totalVoucherRedeemed = data;
    },

    setTotalVoucherValue(state, data) {
        state.totalVoucherValue = data;
    },

    setTotalPromotionQuantitySold(state, data) {
        state.totalPromotionQuantitySold = data;
    },

    setTotalPromotionSales(state, data) {
        state.totalPromotionSales = data;
    },

    setTotalPromotionSold(state, data) {
        state.totalPromotionSold = data;
    },
};

const actions = {
    async getShellAppVoucherPromotionSummary({ commit, dispatch }, options) {
        dispatch('totalLoyaltyTransactions', options);
        dispatch('totalVoucherRedeemed', options);
        dispatch('totalVoucherValue', options);
        dispatch('totalPromotionQuantitySold', options);
        dispatch('totalPromotionSales', options);
        dispatch('totalPromotionSold', options);
    },

    async totalLoyaltyTransactions({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-royalty-transaction');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalLoyaltyTransactions',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-royalty-transaction');

            commit('setTotalLoyaltyTransactions', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-royalty-transaction');

            throw e;
        }
    },

    async totalVoucherRedeemed({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-voucher-redeemed');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalVoucherRedeemed',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-voucher-redeemed');

            commit('setTotalVoucherRedeemed', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-voucher-redeemed');

            throw e;
        }
    },

    async totalVoucherValue({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-voucher-value');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalVoucherValue',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-voucher-value');

            commit('setTotalVoucherValue', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-voucher-value');

            throw e;
        }
    },

    async totalPromotionQuantitySold({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-promotion-quantity-sold');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionQuantitySold',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-promotion-quantity-sold');

            commit('setTotalPromotionQuantitySold', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-promotion-quantity-sold');

            throw e;
        }
    },

    async totalPromotionSales({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-promotion-sales');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionSales',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-promotion-sales');

            commit('setTotalPromotionSales', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-promotion-sales');

            throw e;
        }
    },

    async totalPromotionSold({ commit, dispatch }, options) {
        startLoading(dispatch, 'get-total-promotion-sold');

        let url = Laroute.route(
            'franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionSold',
        );

        try {
            const { data } = await axios.post(url, options);
            endLoading(dispatch, 'get-total-promotion-sold');

            commit('setTotalPromotionSold', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-total-promotion-sold');

            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/shell-app-voucher-promotion.js